<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 240px">
        <p>所属供应商：</p>
        <el-input v-model="carriersIpt" size="mini" style="width:150px" placeholder="请输入供应商名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>司机姓名：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入司机姓名"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>司机类型：</p>
        <el-select v-model="typeIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>联系手机号：</p>
        <el-input v-model="tellIpt" size="mini" style="width:150px" placeholder="请输入联系手机号"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>绑定车辆：</p>
        <el-input v-model="carIpt" size="mini" style="width:150px" placeholder="请输入绑定车辆"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>出车状态：</p>
        <el-select v-model="carStateIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in carStateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>司机状态：</p>
        <el-select v-model="driverStateIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in driverStateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"
                           :index="(index)=>{ return this.size *(this.page -1) + index +1}">
          </el-table-column>
          <el-table-column prop="fleetName" label="所属供应商" align="center"/>
          <el-table-column prop="account" label="登录账号" align="center"/>
          <el-table-column prop="name" label="司机姓名" align="center"/>
          <el-table-column label="司机类型" align="center">
            <div slot-scope="scope">{{getType(scope.row.type)}}</div>
          </el-table-column>
          <el-table-column prop="phoneNumber" label="联系手机号" min-width="110" align="center"/>
          <!-- <el-table-column prop="gender" label="性别" align="center">
            <div slot-scope="scope">{{scope.row.gender?'男':'女'}}</div>
          </el-table-column>
          <el-table-column prop="age" label="年龄" align="center"/>
          <el-table-column label="驾龄" align="center" prop="drivingAge"/>
          <el-table-column label="驾驶证等级" align="center" prop="level"/> -->
          <el-table-column prop="bindCarName" label="绑定车辆" align="center">
            <template slot-scope="scope">
              <!-- //绑定车辆状态 0：未绑定 1：已绑定 -->
              {{scope.row.bindCarType ===1? scope.row.bindCarName : '未绑定'}}
            </template>
          </el-table-column>
          <el-table-column label="出车状态" align="center">
            <div slot-scope="scope">{{getCar(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="司机状态" align="center">
            <div slot-scope="scope">{{getDriver(scope.row.isEnable)}}</div>
          </el-table-column>
          <el-table-column label="操作" min-width="300" align="center">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.isEnable" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row.id)" class="yellow-bg">修改</el-button>
                <el-button size="mini" type="primary" @click="bindClick(scope.row)" class="resetBtn">绑定车辆</el-button>
                <!-- <el-button size="mini" type="primary" @click="resetClick(scope.row.id)" class="resetBtn">重置密码</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='600px' center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="depart">
        <el-form :model="teamData" label-width="150px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" prop="basic" divStyle="margin-top: 10px">
            <el-form-item label="所属供应商：" prop="team" style="margin-top: 15px">
              <el-select v-model="teamData.team" filterable size="mini" style="width:80%" placeholder="请选择车队" value-key="id" @change="carChangeData">
                <el-option v-for="item in teamOption2" :key="item.id" :label="item.name" :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="登录账号：" prop="account">
              <el-input
                :style="'width:80%'"
                v-model="teamData.account"
                placeholder="请输入登录账号"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item label="登录密码：" v-if='dialogTitle !== "修改司机"' prop="password">
              <el-input
                :style="'width:80%'"
                v-model="teamData.password"
                placeholder="请输入登录密码"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item label="司机类型：" prop="type">
              <el-radio-group v-model="teamData.type" size="mini">
                <el-radio :label="1">板车司机</el-radio>
                <el-radio :label="2">地跑司机</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="司机姓名：" prop="name">
              <el-input
                :style="'width:80%'"
                v-model="teamData.name"
                placeholder="请输入司机姓名"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item label="联系手机号：" prop="phoneNumber">
              <el-input
                :style="'width:80%'"
                v-model="teamData.phoneNumber"
                placeholder="请输入联系手机号"
                autocomplete="off"
                size="mini"
              />
              <!-- <el-tooltip content="此手机号作为司机登录账号" placement="top" effect="light">
                <i class="el-icon-warning"/>
              </el-tooltip> -->
            </el-form-item>
            <el-form-item label="性别：" prop="sex">
              <el-radio-group v-model="teamData.sex" size="mini">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="年龄：" prop="age">
              <el-input
                :style="'width:80%'"
                v-model="teamData.age"
                placeholder="请输入司机年龄"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item label="家庭住址：" prop="address">
              <el-input
                :style="'width:80%'"
                v-model="teamData.address"
                placeholder="请输入司机家庭住址"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item label="身份证号：" prop="idNumber" style="margin-bottom: 20px;">
              <el-input
                :style="'width:80%'"
                v-model="teamData.idNumber"
                placeholder="请输入司机身份证号"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <div>
              <span style="font-size:14px;color: #606266;font-weight:700;margin-left: 32px;"><span style="color:red">*</span>身份证(正反面)：</span>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="uploadData"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :on-success=" res => uploadImgFun(res, 1)"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false">
                  <div class="img-box">
                    <img :src="teamData.idCardFrontAttaPath ? baseImgUrl + teamData.idCardFrontAttaPath : imgSrc" alt="">
                    <span class="tips">点击上传或替换身份证正面照片</span>
                  </div>
              </el-upload>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="uploadData"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :on-success=" res => uploadImgFun(res, 2)"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false">
                  <div class="img-box">
                    <img :src="teamData.idCardBackAttaPath ? baseImgUrl + teamData.idCardBackAttaPath : imgSrc" alt="">
                    <span class="tips">点击上传或替法人身份证反面照片</span>
                  </div>
              </el-upload>
            </div>
            <el-form-item label="绑定车辆：">
              <el-select v-model="teamData.car" filterable size="mini" style="width:80%" placeholder="请先选择所属供应商">
                <el-option v-for="item in carOption" :key="item.id" :label="item.license" :value="item"/>
              </el-select>
            </el-form-item>
          </div-border>
          <div-border label="证书信息" prop="certificate" divStyle="margin-top: 10px">
            <el-form-item label="驾龄：" prop="license" style="margin-top: 15px">
              <el-input
                :style="'width:80%'"
                v-model="teamData.license"
                placeholder="请输入司机驾龄"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item label="驾驶证等级：" prop="level" style="margin-bottom: 20px;">
             <!-- <el-select v-model="teamData.level" size="mini" style="width:80%" placeholder="请选择驾驶证等级">
               <el-option v-for="item in levelOption" :key="item.label" :label="item.label" :value="item.value"/>
             </el-select> -->
              <el-input size="mini" v-model="teamData.level" style="width:80%" placeholder="请选择驾驶证等级"></el-input>
            </el-form-item>
            <div>
              <span style="font-size:14px;color: #606266;font-weight:700;margin-left: 32px;"><span style="color:red">*</span>驾驶证(正反面)：</span>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="uploadData"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :on-success=" res => uploadImgFun(res, 3)"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false">
                  <div class="img-box">
                      <img :src="teamData.driverLicenseFrontPath ? baseImgUrl + teamData.driverLicenseFrontPath : imgSrc" alt="">
                      <span class="tips">点击上传或替换驾驶证照片正面照片</span>
                  </div>
              </el-upload>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="uploadData"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :before-upload="beforeAvatarUpload"
                :on-success=" res => uploadImgFun(res, 4)"
                :show-file-list="false">
                  <div class="img-box">
                    <img :src="teamData.driverLicenseBackPath ? baseImgUrl + teamData.driverLicenseBackPath : imgSrc" alt="">
                    <span class="tips">点击上传或替换驾驶证照片反面照片</span>
                  </div>
              </el-upload>
            </div>
            <div>
              <span style="font-size:14px;color: #606266;font-weight:700;margin-left: 5px;"><span style="color:red">*</span>从业资格证(正反面)：</span>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="uploadData"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :before-upload="beforeAvatarUpload"
                :on-success=" res => uploadImgFun(res, 5)"
                :show-file-list="false">
                <div class="img-box">
                  <img :src="teamData.certificateFrontPath ? baseImgUrl + teamData.certificateFrontPath : imgSrc" alt="">
                  <span class="tips">点击上传或替从业资格证正面照片</span>
                </div>
              </el-upload>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="uploadData"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :before-upload="beforeAvatarUpload"
                :on-success=" res => uploadImgFun(res, 6)"
                :show-file-list="false">
                  <div class="img-box">
                    <img :src="teamData.certificateBackPath ? baseImgUrl + teamData.certificateBackPath : imgSrc" alt="">
                    <span class="tips">点击上传或替从业资格证反面照片</span>
                  </div>
              </el-upload>
            </div>
          </div-border>
          <div class="btnContainer">
            <el-button class="searchBtn" size="medium" :loading="addLoad" @click="addClick">{{this.dialogTitle==='添加司机'?'添加':'修改'}}</el-button>
            <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='630px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p :style="`color:${detailData.isEnable?'rgba(51, 136, 255, 1)':'#f78989'}`">{{getState(detailData.isEnable)}}</p>
           <!-- <p>{{detailData.state}}</p> -->
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">所属供应商：</span>
                <span>{{detailData.fleetName}}</span>
              </div>
              <div>
                <span class="span1">司机姓名：</span>
                <span>{{detailData.name}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">司机类型：</span>
                <span>{{getType(detailData.type)}}</span>
              </div>
              <div>
                <span class="span1">绑定车辆：</span>
                <span>{{detailData.bindCarName}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">联系手机号：</span>
              <span>{{detailData.phoneNumber}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">性别：</span>
                <span>{{getSex(detailData.gender)}}</span>
              </div>
              <div>
                <span class="span1">年龄：</span>
                <span>{{detailData.age}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">家庭住址：</span>
              <span>{{detailData.address}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">身份证号：</span>
              <span>{{detailData.idCard}}</span>
            </div>
            <div class="baseInfoContentItem">
              <div style="display: flex;">
                <span class="span1">身份证(正反面)：</span>
                <el-image
                  v-for="(item,index) in detailData.cardImg"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px; "
                  :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                  :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                  fit="cover"/>
              </div>
            </div>
          </div>
        </div>
        <div class="baseInfo" v-if="detailData.driverCertificateDoc">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>证书信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">驾龄：</span>
                <span>{{detailData.driverCertificateDoc.age}}</span>
              </div>
              <div>
                <span class="span1">驾驶证等级：</span>
                <span>{{detailData.driverCertificateDoc.level}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <div style="display: flex;">
                <span class="span1">驾驶证(正反面)：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <el-image
                  v-for="(item,index) in detailData.licenseImg"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px; "
                  :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                  :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                  fit="cover"/>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <div style="display: flex;">
                <span class="span1">从业资格证(正反面)：</span>
                <el-image
                  v-for="(item,index) in detailData.certificate"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px; "
                  :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                  :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                  fit="cover"/>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作记录</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="绑定车辆" :visible.sync="bindVisible" width="600px" @close="bindClose">
      <div class="depart">
        <el-form :model="bind" v-if="bind.bindCarType!=1" style="padding:0px 30px 0" ref="formBind" label-width="70px" :rules="bindRules">
          <el-form-item prop="license" label="车牌号：">
            <el-select v-model="bind.license" size="mini" style="width:100%" filterable value-key="id" placeholder="请先选择所属供应商">
              <el-option v-for="item in carOption" :key="item.id" :label="item.license" :value="item"/>
            </el-select>
            <!-- <el-input v-model="bind.license" placeholder="请输入车牌号" autocomplete="off" size="small" /> -->
          </el-form-item>
          <div class="btnContainer">
            <el-button @click="bindAddClick" :loading="addLoad" class="searchBtn" size="medium">确认</el-button>
            <el-button @click="bindClose" size="medium">关闭</el-button>
          </div>
        </el-form>
        <div class="detail" v-else>
          <div class="baseInfo">
            <div class="baseInfoTitle">
              <div class="line"/>
              <span>基础信息</span>
              <p :style="getStyle(bind.isEnable)">{{getState(bind.isEnable)}}</p>
              <span style="display:inline-block;width:65%;text-align:right;">
                <el-button size="mini" type="primary" :loading="addLoad" @click="unbindClick(bind)" class="resetBtn">解绑车辆</el-button>
              </span>
            </div>
            <div class="baseInfoContent">
              <div class="baseInfoContentItem">
                <span class="span1">所属供应商：</span>
                <span>{{bind.fleetName}}</span>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">车牌号：</span>
                <span>{{bind.license}}</span>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">品牌：</span>
                  <span>{{bind.brand}}</span>
                </div>
                <div>
                  <span class="span1">型号：</span>
                  <span>{{bind.model}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">发动机号：</span>
                  <span>{{bind.engine}}</span>
                </div>
                <div>
                  <span class="span1">档位：</span>
                  <span>{{bind.gear}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">前后轴继承：</span>
                  <span>{{bind.loadAround}}</span>
                </div>
                <div>
                  <span class="span1">整车尺寸：</span>
                  <span>{{bind.sizeLong}}*{{bind.sizeWidth }}*{{bind.sizeHeight }}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">最大承载：</span>
                  <span>{{bind.loadMax}}</span>
                </div>
                <div>
                  <span class="span1">最大托运数量：</span>
                  <span>{{bind.checkMax}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">绑定司机：</span>
                <span>{{bind.driverName}}</span>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">照片：</span>
                <div class="imgContainer">
                  <el-image
                    v-for="(item,index) in bind.img"
                    :key="index"
                    style="width: 100px; height: 100px;margin-right:10px; "
                    :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                    :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                    fit="cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import divBorder from "@/components/divBorder";
import {driverPageList, driverIsEnable, driverDetail, driverAdd, driverUpdate, rePassword
  ,getHighwayParam,driverSelectCarByDriver,bindDetail,bindVehicle,unbindVehicle
} from "@/service/basicfile";
import {formatDateTime, getSessionStore, removeSpace} from "@/config/mUtils";
import { baseUrl, baseImgUrl } from '@/config/env';

export default {
  components: {
    divBorder,
  },
  data() {
    const validateTell = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入司机联系手机号'));
      } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const validateIdNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入司机身份证号'));
      } else if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/).test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    };
    return {
      nameIpt:'',
      carriersIpt:'',
      typeIpt:'',
      tellIpt:'',
      carIpt:'',
      carStateIpt:'',
      driverStateIpt:'',
      carriersOption:[
        {value:'',label:'全部',},
        {value:'车队1',label:'车队1',},
      ],
      typeOption:[
        {value:'',label:'全部',},
        {value:1,label:'板车司机',},
        {value:2,label:'地跑司机',},
      ],
      carStateOption:[
        {value:'',label:'全部',},
        {value:1,label:'运输中',},
        {value:2,label:'待出车',},
        {value:0  ,label:'空闲中',},
      ],
      driverStateOption:[
        {value:'',label:'全部',},
        {value:0,label:'禁用',},
        {value:1,label:'启用',},
      ],
      teamOption:[
        {value:0,label:'全部',},
        {value:1,label:'xxxxx车队1',},
        {value:2,label:'xxxxx车队2',},
      ],
      tableLoad:false,
      TableDatas:[],
      page:1,
      size:10,
      total:0,
      dialogTitle:'',
      dialogVisible:false,
      uploadData: {
        fileType: '1',
      },
      teamData:{
        car:'',
        team:'',
        account:'',
        password:'',
        phoneNumber: '',
        name:'',
        sex:'',
        age:'',
        level:'',
        type:'',
        license:'',
        transport:'',
        address:'',
        idNumber:'',
        idCardBackAttaPath:'',
        idCardFrontAttaPath:'',
        driverLicenseFrontPath:'',
        driverLicenseBackPath:'',
        certificateFrontPath:'',
        certificateBackPath:'',
      },
      levelOption:[
        {value:1,label:'C1',},
        {value:2,label:'C2',},
      ],
      carOption:[],
      teamOption2:[],
      roleOption:[
        {value:'普通角色',label:'普通角色'},
        {value:'管理员',label:'管理员'},
        {value:'测试员',label:'测试员'},
      ],
      departmentOption:[
        {value:'财务部',label:'财务部'},
        {value:'市场部',label:'市场部'},
        {value:'市场部',label:'市场部'},
      ],
      rules:{
        team:[
          { required: true, message: '请选择车队', trigger: 'change' },
        ],
        account:[
          { required: true, message: '请输入登录账号', trigger: 'change' },
        ],
        password:[
          { required: true, message: '请输入登录密码', trigger: 'change' },
        ],
        basic:[
          { required: true, message: ' ', trigger: 'blur' },
        ],
        certificate:[
          { required: true, message: ' ', trigger: 'blur' },
        ],
        phoneNumber:[
          { required: true,validator:validateTell, trigger: 'blur' },
        ],
        sex:[
          { required: true, message: '请选择性别', trigger: 'change' },
        ],
        type:[
          { required: true, message: '请选择司机类型', trigger: 'change' },
        ],
        name:[
          { required: true, message: '请输入司机姓名', trigger: 'blur' },
        ],
        age:[
          { required: true, message: '请输入司机年龄', trigger: 'blur' },
        ],
        level:[
          { required: true, message: '请选择司机驾校等级', trigger: 'change' },
        ],
        license:[
          { required: true, message: '请输入司机驾龄', trigger: 'blur' },
        ],
        transport:[
          { required: true, message: '请输入司机道路运输证号', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请输入司机家庭住址', trigger: 'blur' },
        ],
        idNumber:[
          { required: true,validator:validateIdNumber,trigger: 'blur' },
        ],
      },
      detailDialogVisible:false,
      detailData:{},
      token:getSessionStore('token'),
      operationData:[],
      baseImgUrl: baseImgUrl+ '/',
      imgSrc: require('@/assets/images/noimg.png'),
      uploadUrl:'',
      imgSrc2: require('@/assets/images/noimg2.png'),
      addLoad:false,
      bindVisible: false,   // 绑定车辆弹窗显隐控制
      bind: {},   // 绑定车辆数据
      bindRules:{
        license:{ required: true, message: '请输入车牌号', trigger: 'change' },
      }
    };
  },
  computed:{
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
    getType(){
      return function(type){
        switch(type) {
          case 1:
            return '板车司机'
          case 2:
            return '地跑司机'
        }
      };
    },
    getCar(){
      return function(car){
        switch(car) {
          case 1:
            return '运输中'
          case 2:
            return '待出车'
          case 0:
            return '空闲中'
        }
      };
    },
    getDriver(){
      return function(isEnable){
        switch(isEnable) {
          case 1:
            return '启用'
          case 0:
            return '禁用'
        }
      };
    },
    getState(){
      return function(state){
        switch(state) {
          case 1:
            return '启用中'
          case 0:
            return '禁用中'
        }
      };
    },
    getSex(){
      return function(sex){
        switch(sex) {
          case 1:
            return '男'
          case 0:
            return '女'
        }
      };
    },
    getStyle() {
      return (val) => {
        switch (val) {
          case 1:
            return 'color: #3388ff'
          case 0:
            return 'color:#F56C6C;'
        }
      }
    },
  },
  mounted() {
    this._driverPageList();
    this.uploadUrl = baseUrl + '/web/attachmentFtp/upload'
  },
  methods: {
    async _driverPageList(){
      this.tableLoad=true;
      const obj={
        fleetName:this.carriersIpt,
        name:this.nameIpt,
        type:this.typeIpt,
        account:this.tellIpt,
        bindCarName:this.carIpt,
        status:this.carStateIpt,
        isEnable:this.driverStateIpt,
        rows:this.size,
        page:this.page,
      };
      const res = await driverPageList(obj);
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    async _getHighwayParam(){
      let res =await getHighwayParam()
      if(res.status !== 0) return this.$message.error(res.message);
      this.carriersOption = this.teamOption2 = res.data.map(item=>{
        return{
          id:item.id,
          name:item.name
        }
      })
    },
    //供应商id
    async _driverSelectCarByDriver(id){
      let res =await driverSelectCarByDriver(id)
      if(res.status !== 0) return this.$message.error(res.message);
      this.carOption = res.data.map(item=>{
        return{
          license:item.license,
          id:item.id
        }
      })
    },
    uploadImgFun(res, val) {
      this.addLoad = false;
      let token = getSessionStore('token');
      if(res.status === 0) {
        this.$message.success(res.message);
        switch (val) {
          case 1:
            this.teamData.idCardFrontAttaPath = "web/attachmentFtp/download?attachmentId="+(res.data.id)+"&access_token="+token;
            break;
          case 2:
            this.teamData.idCardBackAttaPath = "web/attachmentFtp/download?attachmentId="+(res.data.id)+"&access_token="+token;
            break;
          case 3:
            this.teamData.driverLicenseFrontPath = "web/attachmentFtp/download?attachmentId="+(res.data.id)+"&access_token="+token;
            break;
          case 4:
            this.teamData.driverLicenseBackPath = "web/attachmentFtp/download?attachmentId="+(res.data.id)+"&access_token="+token;
            break;
          case 5:
            this.teamData.certificateFrontPath = "web/attachmentFtp/download?attachmentId="+(res.data.id)+"&access_token="+token;
            break;
          case 6:
            this.teamData.certificateBackPath = "web/attachmentFtp/download?attachmentId="+(res.data.id)+"&access_token="+token;
            break;
        }
      }else{
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {

      const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
      const isJPG =TypeArr.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB')
      }
      this.addLoad = true;
      return isJPG && isLt10M
    },
    resetBtn(){
      this.nameIpt='';
      this.carriersIpt='';
      this.typeIpt='';
      this.tellIpt='';
      this.carIpt='';
      this.carStateIpt='';
      this.driverStateIpt='';
    },
    searchBtn(){
      this.page = 1;
      this._driverPageList();
    },
    addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='添加司机';
      this.teamData={
        car:'',
        team:'',
        account:'',
        name:'',
        sex:'',
        age:'',
        password: '',
        phoneNumber: '',
        level:'',
        type:'',
        license:'',
        transport:'',
        address:'',
        idNumber:'',
        idCardBackAttaPath:'',
        idCardFrontAttaPath:'',
        driverLicenseFrontPath:'',
        driverLicenseBackPath:'',
        certificateFrontPath:'',
        certificateBackPath:'',
      }
      this._getHighwayParam()
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._driverPageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._driverPageList();
    },
    async detailClick(item){
      this.detailDialogVisible=true;
      const res = await driverDetail(item.id);
      if(res.status !== 0) return this.$message.error(res.message);
      let token = getSessionStore('token');
      let url = "web/attachmentFtp/download?attachmentId="+(item.id||item.response.data.id)+"&access_token="+token;
      this.detailData= {
        ...res.data,
        cardImg: [],
        // cardImg:res.data.cardImg.split(','),
        licenseImg:[],
        certificate:[],
      }
      if(res.data.cardImg) {
        this.detailData.cardImg = res.data.cardImg.split(',');
      }
      if(res.data.driverCertificateDoc) {
        if(res.data.driverCertificateDoc.licenseUrl01) { this.detailData.licenseImg.push(res.data.driverCertificateDoc.licenseUrl01); }
        if(res.data.driverCertificateDoc.licenseUrl02) { this.detailData.licenseImg.push(res.data.driverCertificateDoc.licenseUrl02); }
        // this.detailData.licenseImg = [res.data.driverCertificateDoc.licenseUrl01||'',res.data.driverCertificateDoc.licenseUrl02];
        if(res.data.driverCertificateDoc.practiceUrl01) { this.detailData.licenseImg.push(res.data.driverCertificateDoc.practiceUrl01); }
        if(res.data.driverCertificateDoc.practiceUrl02) { this.detailData.licenseImg.push(res.data.driverCertificateDoc.practiceUrl02); }
        // this.detailData.certificate = [res.data.driverCertificateDoc.practiceUrl01||'',res.data.driverCertificateDoc.practiceUrl02];
      }
      this.operationData=res.data.operateRecordList;
    },
    resetClick(id){
      this.$confirm('确定要重置密码吗？重置密码后，默认密码为：888888', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await rePassword(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._driverPageList();
      }).catch(() => {});
    },
    disableClick(id){
      this.$confirm('确定要禁用当前司机吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await driverIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._driverPageList();
      }).catch(() => {});
    },
    enableClick(id){
      this.$confirm('确定要启用当前司机吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await driverIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._driverPageList();
      }).catch(() => {});
    },
    async changeClick(id){
      this.dialogVisible=true;
      this.dialogTitle='修改司机';
      const res = await driverDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.teamData={
        ...res.data,
        team:res.data.fleetName,
        account:res.data.account,
        password:res.data.password || '',
        phoneNumber:res.data.phoneNumber,
        name:res.data.name,
        sex:res.data.gender,
        age:res.data.age,
        level:res.data.driverCertificateDoc.level,
        license:res.data.driverCertificateDoc.age,
        type:res.data.type,
        address:res.data.address,
        idNumber:res.data.idCard,
        car:res.data.bindCarName,
        idCardFrontAttaPath:"web/attachmentFtp/download?attachmentId="+(res.data.cardImg.split(',')[0])+"&access_token="+this.token,
        idCardBackAttaPath:"web/attachmentFtp/download?attachmentId="+(res.data.cardImg.split(',')[1])+"&access_token="+this.token,
        driverLicenseFrontPath:"web/attachmentFtp/download?attachmentId="+(res.data.driverCertificateDoc.licenseUrl01||'')+"&access_token="+this.token,
        driverLicenseBackPath:"web/attachmentFtp/download?attachmentId="+(res.data.driverCertificateDoc.licenseUrl02||'')+"&access_token="+this.token,
        certificateFrontPath:"web/attachmentFtp/download?attachmentId="+(res.data.driverCertificateDoc.practiceUrl01||'')+"&access_token="+this.token,
        certificateBackPath:"web/attachmentFtp/download?attachmentId="+(res.data.driverCertificateDoc.practiceUrl02||'')+"&access_token="+this.token,
      };
      await this._getHighwayParam()

    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
    addClick(){
      this.teamData=removeSpace(this.teamData);
      console.log(this.teamData)
     let idCardFrontAttaPath = this.teamData.idCardFrontAttaPath.match(/attachmentId=(.*)&/)[1]
     let idCardBackAttaPath = this.teamData.idCardBackAttaPath.match(/attachmentId=(.*)&/)[1]
     let licenseUrl01 = this.teamData.driverLicenseFrontPath.match(/attachmentId=(.*)&/)[1]
     let licenseUrl02 =this.teamData.driverLicenseBackPath.match(/attachmentId=(.*)&/)[1]
     let practiceUrl01 =this.teamData.certificateFrontPath.match(/attachmentId=(.*)&/)[1]
     let practiceUrl02 =this.teamData.certificateBackPath.match(/attachmentId=(.*)&/)[1]
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.addLoad = true;
          const obj = {
            id:this.teamData.id,
            fleetId:(this.teamData.team.id||this.teamData.fleetId),
            fleetName:(this.teamData.team.name||this.teamData.fleetName),
            name:this.teamData.name,
            account:this.teamData.account,
            password:this.teamData.password,
            phoneNumber:this.teamData.phoneNumber,
            type:this.teamData.type,
            gender:this.teamData.sex,
            age:this.teamData.age,
            address:this.teamData.address,
            idCard:this.teamData.idNumber,
            cardImg:idCardFrontAttaPath+','+idCardBackAttaPath,
            bindCarId:this.teamData.car ?this.teamData.car.id :"",
            bindCarName:this.teamData.car ?this.teamData.car.license:"",
            driverCertificateDoc:{
              age:this.teamData.license,
              level:this.teamData.level,
              licenseUrl01:licenseUrl01,
              licenseUrl02:licenseUrl02,
              practiceUrl01:practiceUrl01,
              practiceUrl02:practiceUrl02,
            },
          };
          // console.log(obj);
          const res = this.dialogTitle==='添加司机'? await driverAdd(obj):await driverUpdate(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          else this.$message.success(res.message);
          await this._driverPageList();
          this.dialogVisible=false;
        } else return false;
      });
    },
    carChangeData(value){
      this._driverSelectCarByDriver(value.id)
    },
    // 解绑车辆
    async unbindClick(row){
      this.$confirm('确定要给当前司机解绑运输车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.addLoad = true;
        const res = await unbindVehicle(row.driverId);
        this.addLoad = false;
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        this._driverPageList();
        this.bindClose();
      }).catch(() => {});
    },
    // 绑定车辆 —— 打开弹窗
    async bindClick(row) {
      this.bind.bindCarType = row.bindCarType;
      this.bind.id = row.id;
      this.bind.fleetId = row.fleetId;
      if(row.bindCarType == 1){
        let res = await bindDetail(row.bindCarId);
        if(res.status !== 0) return this.$message.error(res.message);
        this.bind = {
          ...res.data,
          img:res.data.carUrl01?res.data.carUrl01.split(","):'',
          bindCarType: row.bindCarType
        }
      }else {
        this._driverSelectCarByDriver(row.fleetId);
      }
      this.bindVisible = true;
    },
    // 绑定车辆 —— 关闭弹窗
    bindClose() {
      this.bindVisible = false;
      for(let ket in this.bind) {
        this.bind[ket] = '';
      }
    },
    // 绑定车辆 —— 确认按钮
    async bindAddClick(){
      this.$refs.formBind.validate(async (valid) => {
        if (valid) {
          let obj = {
            id: this.bind.id,
            bindCarId: this.bind.license.id,
            fleetId: this.bind.fleetId,
          }
          this.addLoad = true;
          let res = await bindVehicle(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this._driverPageList();
          this.bindClose();
        } else return false;
      });
    }
  },
};
</script>



<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;
  .img-box{
    position: relative;
    width: 150px;
    height: 100px;
    img{
      width: 150px;
      height: 100px;
    }
    .tips{
      position: absolute;
      display:none;
    }
    &:hover .tips{
      display:block;
      position:absolute;
      bottom:0;
      top:0;
      left:0;
      color:#FFF;
      width:146px;
      z-index:10;
      height:148px;
      background:#000;
      opacity: 0.6;
    }
  }
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 10px;
    // max-height:70vh;
    // overflow: auto;
    .upload-demo {
      display: inline-block;
      width: 170px;
      .img-box{
        width: 130px;
        height: 80px;
        img{
          width: 130px;
          height: 80px;
        }
        &:hover .tips{
          width: 130px;
          height: 80px;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom:12px;
      }
      //.el-input__inner{
      //  border: none;
      //}
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
         position: relative;
       }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .permissions{
    width:100%;
    padding: 20px 10px 20px 50px;
    .name{
      display:flex;
      align-items:center;
      margin-bottom: 20px;
      span{
        color: #2F1010;
      }
    }
    .content1{
      p{
        color: #2F1010;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    // max-height:70vh;
    // overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:60%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      max-height: 70vh;
      overflow-y: auto;
      padding: 20px 20px 10px;
    }
  }
}
</style>
